
import React from 'react';
import GlassCard from './common/GlassCard';
import Button from './common/Button';
import "./HeroSection.scss";
import * as Constants from '../constants';
import type { PainPoint, HowItWorksStep } from '../types';
import { QuestionMarkCircleIcon, UserGroupIcon, FaceSmileIcon, ClockIcon, ListBulletIcon, ChatBubbleLeftRightIcon, DocumentChartBarIcon, ArrowTrendingUpIcon, LightBulbIcon } from './icons/Heroicons';

const painPoints: PainPoint[] = [
  { icon: <QuestionMarkCircleIcon className="w-10 h-10 text-pink-500 mb-3" />, title: Constants.PAIN_POINT_1_TITLE, description: Constants.PAIN_POINT_1_DESC },
  { icon: <UserGroupIcon className="w-10 h-10 text-pink-500 mb-3" />, title: Constants.PAIN_POINT_2_TITLE, description: Constants.PAIN_POINT_2_DESC },
  { icon: <FaceSmileIcon className="w-10 h-10 text-pink-500 mb-3" />, title: Constants.PAIN_POINT_3_TITLE, description: Constants.PAIN_POINT_3_DESC },
  { icon: <ClockIcon className="w-10 h-10 text-pink-500 mb-3" />, title: Constants.PAIN_POINT_4_TITLE, description: Constants.PAIN_POINT_4_DESC },
];

const howItWorksSteps: HowItWorksStep[] = [
  { icon: <ListBulletIcon className="w-10 h-10 text-green-500 mb-3" />, title: Constants.HOW_IT_WORKS_STEP_1_TITLE, description: Constants.HOW_IT_WORKS_STEP_1_DESC },
  { icon: <ChatBubbleLeftRightIcon className="w-10 h-10 text-green-500 mb-3" />, title: Constants.HOW_IT_WORKS_STEP_2_TITLE, description: Constants.HOW_IT_WORKS_STEP_2_DESC },
  { icon: <DocumentChartBarIcon className="w-10 h-10 text-green-500 mb-3" />, title: Constants.HOW_IT_WORKS_STEP_3_TITLE, description: Constants.HOW_IT_WORKS_STEP_3_DESC },
  { icon: <ArrowTrendingUpIcon className="w-10 h-10 text-green-500 mb-3" />, title: Constants.HOW_IT_WORKS_STEP_4_TITLE, description: Constants.HOW_IT_WORKS_STEP_4_DESC },
];

const ProblemSolutionSection: React.FC = () => {
  return (
    <section id="problem-solution-section"    className="snap-section pt-24 md:pt-32 bg-gradient-to-br from-slate-100 via-purple-100 to-pink-100">
      <div className="container mx-auto px-6 py-16 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 HeroTitle">
          {Constants.PROBLEM_HEADLINE}
        </h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {painPoints.map((point, index) => (
            <GlassCard key={index} className="flex flex-col items-center hover:shadow-purple-400/40 transition-shadow duration-300 bg-white/60">
              {point.icon}
              <h3 className="text-xl font-semibold mb-2 text-slate-700 ">{point.title}</h3>
              <p className="text-slate-500 text-sm">{point.description}</p>
            </GlassCard>
          ))}
        </div>

       
        <h3 className="text-2xl md:text-3xl font-bold mb-10 text-transparent bg-clip-text bg-gradient-to-r from-green-500 to-teal-600">วิธีการทำงาน</h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {howItWorksSteps.map((step, index) => (
            <GlassCard key={index} className="flex flex-col items-center bg-green-400/10 border-green-400/20 hover:shadow-green-400/40 transition-shadow duration-300">
              {step.icon}
              <h4 className="text-lg font-semibold mb-2 text-slate-700">{step.title}</h4>
              <p className="text-slate-500 text-sm">{step.description}</p>
            </GlassCard>
          ))}
        </div>
        
        {/* <Button variant="secondary" size="lg">
          {Constants.PROBLEM_CTA_SECONDARY}
        </Button> */}
      </div>
    </section>
  );
};

export default ProblemSolutionSection;
